// extracted by mini-css-extract-plugin
export var copyableField = "_rm-4";
export var customerBadge = "_rm-0";
export var customerInfoTitle = "_rm-2";
export var details = "_rm-1";
export var dropdownContainer = "_rm-5";
export var dropdownImage = "_rm-6";
export var editAssigneeForm = "_rm-a";
export var editButton = "_rm-3";
export var email = "_rm-7";
export var hidden = "_rm-d";
export var input = "_rm-8";
export var saveButton = "_rm-b";
export var shopifyIcon = "_rm-c";
export var suggestionBadge = "_rm-e";
export var suggestionText = "_rm-f";
export var username = "_rm-9";